const LocationFields = ({
  formDataUser,
  handleChange,
  handleCityChange,
  countries,
  cities,
  editable,
}) => {
  return (
    <>
      <div>
        <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
          País<span className="text-red-700"> *</span>
        </label>
        <select
          name="country"
          value={formDataUser.country}
          onChange={handleChange}
          disabled={!editable}
          className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
          required
        >
          <option value="">
            {countries.length ? 'Selecciona una opción' : 'Cargando...'}
          </option>
          {countries.map((c) => (
            <option key={c.Id} value={c.Id}>
              {c.Name}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
          Ciudad, departamento o provincia<span className="text-red-700"> *</span>
        </label>
        <select
          name="cityId"
          value={formDataUser.cityId}
          onChange={handleCityChange}
          disabled={!editable || !formDataUser.country}
          className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
          required
        >
          <option value="">
            {formDataUser.country ? 'Selecciona una opción' : 'Seleccione país'}
          </option>
          {formDataUser.country && cities.map((city) => (
            <option key={city.Id} value={city.Id}>
              {city.Name}
            </option>
          ))}
        </select>
      </div>
    </>
  );
};

export default LocationFields;
